import { UPDATESETTINGS_SUCCESS, UPDATESETTINGS_FAIL } from '../actionTypes';

const initialState = {
    user: null
};

const updateSettingsReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATESETTINGS_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case UPDATESETTINGS_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }
    return state;
};

export default updateSettingsReducer;
